<template>
  <div class="container mt-5 mb-5">
    <form>
      <h2 class="text-head" style="padding-top: 20px">ข. รายละเอียดของผู้บาดเจ็บและเสียชีวิต</h2>
      <div class="mt-3 row" style="font-size: 24px">
        <div class="col-lg-3 col-md-3 col-10 row">
          <h2 class="col-lg-6 col-md-6 col-5 text-head " style="font-size: 24px">รายที่</h2>
          <div class="col-lg-5 col-md-6 col-5 " style="margin-top: -10px">
            <input v-model.number="form.order"
                   :disabled="true"
                   class="form-control" min="0">
          </div>
        </div>
        <div class="form-group row pl-3 col-lg-9 col-md-9 col-12">
          <label id="unknown_person" class=" col-lg-4 col-sm-5 col-12 mb-0 text-head">รายละเอียดบุคคล</label>
          <div class="col-lg-4 col-sm-4 col-5 offset-sm-0 offset-1 mb-0 text-head">
            <div class="pl-sm-2 custom-control custom-checkbox custom-checkbox">
              <input id="unknownPerson1" v-model="form.unknown_person"
                     class=" custom-control-input" name="unknownPerson"
                     type="radio"
                     value="1">
              <label class="custom-control-label" for="unknownPerson1">ทราบ</label>
            </div>
          </div>
          <div class="col-lg-4 col-sm-4 col-5 offset-lg-0 offset-sm-5 offset-sm-0 text-head">
            <div class="custom-control custom-checkbox custom-checkbox">
              <input id="unknownPerson2" v-model="form.unknown_person"
                     class="custom-control-input" name="unknownPerson"
                     type="radio"
                     value="2"
                     @change="clearDataPerson()">
              <label class="custom-control-label" for="unknownPerson2">ไม่ทราบ</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-10 row">
          <h2 class="col-lg-6 col-md-6 col-5 text-head " style="font-size: 24px"></h2>
        </div>

        <div class="form-group row pl-3 col-lg-9 col-md-9 col-12">

          <label id="alive" class="col-lg-3 col-sm-5 col-12 mb-0 text-head">สถานะ</label>

          <div class="col-lg-3 col-4 text-head">
            <div class="custom-checkbox custom-checkbox">
              <input id="alive1" v-model="form.alive"
                     class="  custom-control-input"
                     name="alive1"
                     type="radio"
                     value="1"
                     @click="onClickAlive(1)">
              <label class="custom-control-label" for="alive1">เสียชีวิต</label>
            </div>
          </div>
          <div class="col-lg-3 col-4  text-head">
            <div class="custom-checkbox custom-checkbox">
              <input id="alive2" v-model="form.alive"
                     class="custom-control-input"
                     name="alive2"
                     type="radio"
                     value="2"
                     @click="onClickAlive(2)">
              <label class="custom-control-label" for="alive2">บาดเจ็บ</label>
            </div>
          </div>
          <div class="col-lg-3 col-4 text-head">
            <div class="custom-checkbox custom-checkbox">
              <input id="alive3" v-model="form.alive"
                     class="custom-control-input"
                     name="alive3"
                     type="radio"
                     value="3"
                     @click="onClickAlive(3)">
              <label class="custom-control-label" for="alive3">ไม่บาดเจ็บ</label>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 form-div">
        <div class="pt-2 pl-5 pr-3">
          <div class="mt-3 row">
            <div class="col-md-4 form-group row">
              <label class="col-5 col-form-label">1. คำนำหน้าชื่อ</label>
              <div class="col-7">
                <multiselect
                  id="title"
                  v-model="form.title"
                  :options="patientTitleOptions"
                  :disabled="form.unknown_person == 2"
                  deselect-label=""
                  placeholder="คำนำหน้า"
                  select-label=""
                  selectedLabel="">
                </multiselect>
                <input v-if="form.title === 'อื่นๆ'" id="patient_other_title" v-model="form.other_title"
                       :disabled="form.unknown_person == 2"
                       class="form-control mt-1" type="text" placeholder="ระบุคำนำหน้า">
              </div>
            </div>
            <div class="col-md-4 form-group row">
              <label class="col-4 col-form-label">ชื่อ</label>
              <div class="col-8">
                <input id="first_name"
                       v-model="form.first_name"
                       :disabled="form.unknown_person == 2"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="col-md-4 form-group row">
              <label class="col-4 col-form-label">นามสกุล</label>
              <div class="col-8">
                <input id="last_name"
                       v-model="form.last_name"
                       :disabled="form.unknown_person == 2"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="col-md-8 form-group row ">
              <label class="col-lg-5 col-md-5 col-2 col-form-label">เลขประจำตัวประชาชน/เลขหนังสือเดินทาง</label>
              <div class="col-lg-7 col-md-7 col-10">
                <input id="id_number"
                       v-model="form.id_number"
                       :disabled="form.unknown_person == 2"
                       class="form-control">
              </div>
            </div>
            <div id="nationality" class="col-md-4 form-group row ">
              <label class="col-lg-4 col-md-4 col-2 col-form-label">สัญชาติ</label>
              <div class="col-lg-8 col-md-8 col-10">
                <multiselect
                  id="nationality_code"
                  v-model="form.nationality_code"
                  :disabled="form.unknown_person == 2"
                  :options="optionNationality"
                  class="w-100"
                  deselect-label=""
                  label="nation"
                  placeholder="เลือกสัญชาติ"
                  select-label=""
                  selectedLabel=""
                  track-by="id">
                </multiselect>
              </div>
            </div>
          </div>
          <div class="mt-3 row">
            <div class="col-lg-4 col-md-6 form-group row">
              <label class="col-lg-4 col-4 col-form-label">2. ที่อยู่</label>
              <div class=" col-lg-8 col-8">
                <input id="address_no"
                       v-model="form.address_no"
                       :disabled="form.unknown_person == 2"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 form-group row">
              <label class="col-lg-4 col-4 col-form-label">หมู่ที่</label>
              <div class="col-lg-6 col-md-4 col-8">
                <input id="village_no"
                       v-model="form.village_no"
                       :disabled="form.unknown_person == 2"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-7 form-group row">
              <label class="col-lg-4  col-4  col-form-label">จังหวัด</label>
              <div class="col-lg-8 col-8">
                <multiselect
                  id="location_province"
                  v-model="form.location_province"
                  :disabled="form.unknown_person == 2"
                  :options="optionProvince"
                  class="w-100"
                  deselect-label=""
                  label="name"
                  placeholder="เลือกจังหวัด"
                  select-label=""
                  selectedLabel=""
                  track-by="name"
                  @input="getDistricts(form.location_province)">
                </multiselect>
              </div>
            </div>
            <div class=" col-lg-4 col-md-6 col-sm-6 form-group row">
              <label class=" col-lg-4 col-4 col-form-label">อำเภอ</label>
              <div class="col-lg-8 col-8">
                <multiselect
                  id="location_district"
                  v-model="form.location_district"
                  :allow-empty="false"
                  :disabled="form.unknown_person == 2"
                  :options="optionDistrict"
                  class="w-100"
                  deselect-label=""
                  label="name"
                  placeholder="เลือกอำเภอ"
                  select-label=""
                  selectedLabel=""
                  track-by="name"
                  @input="getSubDistricts(form.location_district)">
                </multiselect>

              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-7 form-group row">
              <label class="col-lg-4  col-4  col-form-label">ตำบล</label>
              <div class="col-lg-8 col-8">
                <multiselect
                  id="location_sub_district"
                  v-model="form.location_sub_district"
                  :allow-empty="false"
                  :disabled="form.unknown_person == 2"
                  :options="optionSubDistrict"
                  class="w-100"
                  deselect-label=""
                  label="name"
                  placeholder="เลือกตำบล"
                  select-label=""
                  selectedLabel=""
                  track-by="name">
                </multiselect>
              </div>
            </div>
            <!--                      <div class="col-lg-4 col-md-6 col-sm-7 form-group row">-->
            <!--                        <label class="col-lg-4  col-4  col-form-label">โรงเรียน</label>-->
            <!--                        <div class=" col-lg-8 col-8">-->
            <!--                          <input v-model="form.school"-->
            <!--                                 id="school"-->
            <!--                                 :disabled="form.unknown_person == 2"-->
            <!--                                 class="form-control" type="text">-->
            <!--                        </div>-->
            <!--                      </div>-->
          </div>

          <div class="mt-3 row">
            <div class="col-lg-4 col-md-6 col-12 row form-group">
              <label id="gender_id" class="col-md-4 col-4 col-form-label">3. เพศ</label>
              <div class="col-md-4 col-3 col-form-label">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="gender_man" v-model="form.gender_id"
                         class="custom-control-input" name="gender" type="radio" value="1">
                  <label class="custom-control-label" for="gender_man">ชาย</label>
                </div>
              </div>
              <div class=" col-md-3 col-4 col-form-label">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="gender_woman" v-model="form.gender_id"
                         class="custom-control-input" name="gender" type="radio" value="2">
                  <label class="custom-control-label" for="gender_woman">หญิง</label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12 form-group row">
              <label class="col-md-2 col-4 col-form-label">4. อายุ</label>

              <div class="col-md-3 col-4 form-group">
                <input id="age" v-model="form.age"
                       class="form-control" min="0" type="number">
              </div>
              <label class="col-md-2 col-2 col-form-label">ปี</label>

              <div class="col-md-3 col-4 offset-md-0 offset-4 form-group">
                <input id="age_month" v-model="form.age_month"
                       class="form-control" min="0" type="number" value="0">
              </div>
              <label class="col-md-2 col-2 col-form-label">เดือน</label>
            </div>
          </div>

          <div class="mt-3 row form-group">
            <label id="swimming_id" class="col-12 mb-0">5. ความสามารถในการว่ายน้ำ</label>

            <label id="swimming_id" class="col-md-1 col-12 offset-md-1 offset-1  mb-0">5.1</label>
            <div class="col-md-3 col-11 offset-md-0 offset-2 mb-0">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="swimming1" v-model="form.swimming_id"
                       class="custom-control-input"
                       name="swimming" type="radio"
                       value="1">
                <label class="custom-control-label" for="swimming1">ว่ายน้ำเป็น</label>
              </div>
            </div>
            <div class="col-md-3 col-11 offset-md-0 offset-2 ">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="swimming2" v-model="form.swimming_id"
                       class="custom-control-input" name="swimming"
                       type="radio"
                       value="2">
                <label class="custom-control-label" for="swimming2">ว่ายน้ำไม่เป็น</label>
              </div>
            </div>
            <div class="col-md-3 col-11 offset-md-0 offset-2 ">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="swimming3" v-model="form.swimming_id"
                       class="custom-control-input" name="swimming"
                       type="radio"
                       value="3">
                <label class="custom-control-label"
                       for="swimming3"> ไม่ทราบ/ไม่แน่ใจ </label>
              </div>
            </div>
            <label id="swimming_ability_id" class="col-md-1 col-12 offset-md-1 offset-1  mb-0">5.2</label>
            <div class="col-md-3 col-11 offset-md-0 offset-2 mb-0 ">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="swimming_ability1" v-model="form.swimming_ability_id"
                       class="custom-control-input"
                       name="swimming_ability" type="radio"
                       value="1">
                <label class="custom-control-label" for="swimming_ability1">มีทักษะการเอาชีวิตรอดในน้ำ*</label>
              </div>
            </div>
            <div class="col-md-3 col-11 offset-md-0 offset-2 ">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="swimming_ability2" v-model="form.swimming_ability_id"
                       class="custom-control-input" name="swimming_ability"
                       type="radio"
                       value="2">
                <label class="custom-control-label" for="swimming_ability2">ไม่มีทักษะการเอาชีวิตรอดในน้ำ*</label>
              </div>
            </div>
            <div class="col-md-3 col-11 offset-md-0 offset-2 ">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="swimming_ability3" v-model="form.swimming_ability_id"
                       class="custom-control-input" name="swimming_ability"
                       type="radio"
                       value="3">
                <label class="custom-control-label"
                       for="swimming_ability3">ไม่ทราบ/ไม่แน่ใจ</label>
              </div>
            </div>
            <label class="pl-sm-5 col-11 col-form-label "
                   style="font-size:17px;color: darkgrey;">
              * มีทักษะการเอาชีวิตรอดในน้ำ หมายถึง 1) สามารถลอยตัวเปล่า (ไม่ใช้อุปกรณ์ช่วย)
              อยู่ในน้ำได้นานมากกว่า 3 นาที 2) เคลื่อนที่ไปในน้ำได้ไกล 25 เมตร
            </label>
          </div>

          <div class="mt-3 row">
            <label id="people_with_patient_id" class="col-md-12">6. ขณะเกิดเหตุ (ณ จุดเกิดเหตุ)
              คนที่จมน้ำอยู่กับใคร</label>
            <div class="offset-1 col-lg-2 col-md-3 col-4 col-form-label pb-0">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="people_with_patient1" v-model="form.people_with_patient_id"
                       class="custom-control-input" name="people_with_patient"
                       type="radio"
                       value="1"
                       @change="clearPeopleWithPatient">
                <label class="custom-control-label" for="people_with_patient1">อยู่คนเดียว</label>
              </div>
            </div>
            <div class="col-lg-2 col-md-5 col-6  col-form-label pb-0 ">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="people_with_patient2" v-model="form.people_with_patient_id"
                       class="custom-control-input" name="people_with_patient"
                       type="radio"
                       value="2"
                       @change="clearPeopleWithPatient">
                <label class="custom-control-label" for="people_with_patient2">เพื่อน</label>
              </div>
            </div>
            <div class="offset-lg-0 col-lg-5 col-md-12 offset-1 col-form-label pb-0">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="people_with_patient3" v-model="form.people_with_patient_id"
                       class="custom-control-input" name="people_with_patient"
                       type="radio"
                       value="3">
                <label id="activity_people_with_patient_id" class="custom-control-label" for="people_with_patient3">ผู้ปกครอง/ผู้ดูแลเด็ก
                  โดยขณะนั้นผู้ปกครองทำกิจกรรมดังนี้</label>
              </div>
            </div>
            <div class="offset-lg-6 offset-md-2 col-lg-2 col-md-3 col-5 offset-2 col-form-label pb-0">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="activity_people_with_patient1"
                       v-model="form.activity_people_with_patient_id" :disabled="form.people_with_patient_id != 3 "
                       class="custom-control-input" name="activity_people_with_patient"
                       type="radio"
                       value="1">
                <label class="custom-control-label"
                       for="activity_people_with_patient1">ทำงานบ้าน</label>
              </div>
            </div>
            <div class="col-lg-2 col-md-3 offset-md-0 col-5 col-form-label pb-0">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="activity_people_with_patient2" v-model="form.activity_people_with_patient_id"
                       :disabled="form.people_with_patient_id != 3 "
                       class="custom-control-input" name="activity_people_with_patient"
                       type="radio"
                       value="2">
                <label class="custom-control-label" for="activity_people_with_patient2">นอนหลับ</label>
              </div>
            </div>
            <div class="offset-lg-6 col-lg-2 offset-md-0 col-md-3  offset-2 col-5 col-form-label pb-0">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="activity_people_with_patient3" v-model="form.activity_people_with_patient_id"
                       :disabled="form.people_with_patient_id != 3 "
                       class="custom-control-input" name="activity_people_with_patient"
                       type="radio"
                       value="3">
                <label class="custom-control-label"
                       for="activity_people_with_patient3">ประกอบอาชีพ</label>
              </div>
            </div>
            <div class="offset-lg-0 col-lg-2 offset-md-2 col-md-3 col-5 col-form-label ">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="activity_people_with_patient4" v-model="form.activity_people_with_patient_id"
                       :disabled="form.people_with_patient_id != 3 "
                       class="custom-control-input" name="activity_people_with_patient"
                       type="radio"
                       value="4">
                <label class="custom-control-label" for="activity_people_with_patient4">โทรศัพท์</label>
              </div>
            </div>
            <div class="offset-lg-6 col-lg-4 offset-md-0 col-md-6 offset-2 col-10 row">
              <div class="col-md-6 col-sm-4 col-6 col-form-label custom-control custom-checkbox custom-checkbox">
                <input id="other_activity_people_with_patient"
                       v-model="form.activity_people_with_patient_id"
                       :disabled="form.people_with_patient_id != 3 "
                       class="custom-control-input" name="activity_people_with_patient"
                       type="radio"
                       value="5">
                <label class="custom-control-label"
                       for="other_activity_people_with_patient">
                  อื่นๆ โปรดระบุ
                </label>
              </div>
              <div class="col-6 input-group mb-3 pl-0 pr-0">
                <input v-model="form.other_activity_people_with_patient"
                       :disabled="form.activity_people_with_patient_id!=5"
                       class="form-control" name="other_activity_people_with_patient" type="text">
              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <label id="activity_before_event_id" class="col-12">7. กิจกรรมก่อนเกิดเหตุ (ตอบได้มากกว่า 1 ข้อ)</label>
            <div class="offset-1 col-md-2 col-5">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="activity_before_event1" v-model="form.activity_before_event_id"
                       class="custom-control-input" type="checkbox"
                       value="1">
                <label class="custom-control-label" for="activity_before_event1">พลัดตกลื่น</label>
              </div>
            </div>
            <div class="col-md-2 col-6">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="activity_before_event2" v-model="form.activity_before_event_id"
                       class="custom-control-input" type="checkbox"
                       value="2">
                <label class="custom-control-label" for="activity_before_event2">เล่นน้ำ</label>
              </div>
            </div>
            <div class="col-lg-2 col-md-3 offset-md-0 offset-1 col-5">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="activity_before_event3" v-model="form.activity_before_event_id"
                       class="custom-control-input" type="checkbox"
                       value="3">
                <label class="custom-control-label" for="activity_before_event3">ประกอบอาชีพ</label>
              </div>
            </div>
            <div class="col-md-2 col-6">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="activity_before_event4" v-model="form.activity_before_event_id"
                       class="custom-control-input" type="checkbox"
                       value="4">
                <label class="custom-control-label" for="activity_before_event4">เรือล่ม</label>
              </div>
            </div>
            <div class="offset-1 col-12 row">
              <div class="col-lg-2 col-md-3 col-sm-4 col-form-label custom-control custom-checkbox  pl-0 ">
                <div class="custom-control  custom-checkbox">
                  <input id="activity_before_event5" v-model="form.activity_before_event_id"
                         class="custom-control-input"
                         type="checkbox" value="5"
                         @change="clearActivityBeforeEvent">
                  <label class="custom-control-label" for="activity_before_event5">อื่นๆ
                    โปรดระบุ</label>
                </div>
              </div>
              <div class="col-md-2 col-sm-4 col-6 input-group mb-3 pl-0 pr-0">
                <input id="other_activity_before_event"
                       v-model="form.other_activity_before_event"
                       :disabled="form.activity_before_event_id != null && !form.activity_before_event_id.includes('5')"
                       class="form-control" name="other_activity_before_event" type="text">
              </div>
            </div>

          </div>

          <div class="mt-3 row">
            <label id="caregiver_id" class="col-12">8. ก่อนเกิดเหตุ (ในช่วงปกติ) ใครเป็นผู้ดูแล (ตอบได้มากกว่า 1
              ข้อ)</label>
            <div class="offset-1 col-md-2 col-5 col-form-label">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="caregiver1" v-model="form.caregiver_id"
                       class="custom-control-input" type="checkbox"
                       value="1">
                <label class="custom-control-label" for="caregiver1">พ่อ แม่</label>
              </div>
            </div>
            <div class="col-md-2 col-6 col-form-label">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="caregiver2" v-model="form.caregiver_id"
                       class="custom-control-input" type="checkbox"
                       value="2">
                <label class="custom-control-label" for="caregiver2">ปู่ย่า ตายาย</label>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 offset-md-0 offset-sm-1 col-11 row">
              <div
                class="offset-1 col-lg-4 col-md-5 col-sm-4 col-6 col-form-label custom-control custom-checkbox custom-checkbox">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="caregiver3" v-model="form.caregiver_id"
                         class="custom-control-input"
                         type="checkbox" value="3"
                         @change="clearActivity">
                  <label class="custom-control-label" for="caregiver3">อื่นๆ โปรดระบุ</label>
                </div>
              </div>
              <div class="col-4 input-group mb-3 pl-0 pr-0">
                <input id="other_caregiver"
                       v-model="form.other_caregiver"
                       :disabled="form.caregiver_id != null && !form.caregiver_id.includes('3')"
                       class="form-control" name="other_caregiver" type="text">

              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <label class="col-lg-4 col-12 col-form-label ">9. ระยะทางโดยประมาณระหว่างบ้านถึงที่เกิดเหตุ</label>
            <div class="offset-lg-0 col-lg-3 offset-1 col-md-4 col-sm-5 col-12 row form-group">
              <div class="col-7">
                <input id="distance_kilometre"
                       v-model.number="form.distance_kilometre"
                       :disabled="form.has_event_at_home_id == 1"
                       class="form-control" min="0" type="number">
              </div>
              <label class="col-5 col-form-label">กิโลเมตร</label>
            </div>
            <div class="offset-sm-0 col-lg-3 col-md-4 col-sm-5 offset-1 col-12 row form-group">
              <div class="col-7">
                <input id="distance_metre"
                       v-model.number="form.distance_metre"
                       :disabled="form.has_event_at_home_id == 1"
                       class="form-control" min="0" type="number">
              </div>
              <label class="col-5 col-form-label">เมตร</label>
            </div>
            <div
              class="pl-md-0 pl-4 offset-md-0 col-lg-2 col-md-3 offset-1 col-sm-6 col-12 row col-form-label form-group">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="event_at_home" v-model="form.has_event_at_home_id"
                       class="custom-control-input"
                       type="checkbox" value="true"
                       @change="clearDistance">
                <label class="custom-control-label" for="event_at_home">เหตุเกิดภายในบ้าน</label>
              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <label id="has_floating_device_id" class="col-lg-4 col-12 ">10. การใช้อุปกรณ์ช่วยลอยน้ำขณะเกิดเหตุ</label>
            <div class="col-lg-2">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="has_floating_device2" v-model="form.has_floating_device_id"
                       class="custom-control-input"
                       name="has_floating_device" type="radio"
                       value="2"
                       @change="clearFloatingDevice">
                <label class="custom-control-label" for="has_floating_device2">ไม่มี</label>
              </div>
            </div>
            <!--            <div class="offset-lg-0 col-md-1 offset-1 col-2  col-sm-12">-->
            <div class="col-lg-2">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="has_floating_device1" v-model="form.has_floating_device_id"
                       class="custom-control-input" name="has_floating_device"
                       type="radio"
                       value="1">
                <label id="floating_device_id" class="custom-control-label" for="has_floating_device1">มี</label>
              </div>
            </div>

            <!--            <div class="offset-lg-6 offset-md-1 offset-sm-1 offset-2 col-8 row">-->
            <div class="row offset-lg-6 offset-md-1" style="padding-left: 2rem">
              <div class="col-10 ">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="floating_device1" v-model="form.floating_device_id"
                         :disabled="form.has_floating_device_id !=1 "
                         class="custom-control-input"
                         name="floating_device" type="radio"
                         value="1"
                         @change="clearHasFloatingDeviceId">
                  <label class="custom-control-label" for="floating_device1">ห่วงยาง/ห่วงชูชีพ</label>
                </div>
              </div>
              <div class="col-10">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="floating_device2" v-model="form.floating_device_id"
                         :disabled="form.has_floating_device_id !=1 "
                         class="custom-control-input"
                         name="floating_device" type="radio"
                         value="2"
                         @change="clearHasFloatingDeviceId">
                  <label class="custom-control-label"
                         for="floating_device2">ขวดน้ำ/แกลลอนพลาสติก</label>
                </div>
              </div>
              <div class="col-10">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="floating_device3" v-model="form.floating_device_id"
                         :disabled="form.has_floating_device_id !=1 "
                         class="custom-control-input"
                         name="floating_device" type="radio"
                         value="3"
                         @change="clearHasFloatingDeviceId">
                  <label class="custom-control-label" for="floating_device3">วัสดุธรรมชาติ</label>
                </div>
              </div>
              <div class="col-10">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="floating_device4" v-model="form.floating_device_id"
                         :disabled="form.has_floating_device_id !=1 "
                         class="custom-control-input" name="floating_device"
                         type="radio"
                         value="4">
                  <label class="custom-control-label" for="floating_device4">อื่นๆ โปรดระบุ</label>
                </div>
                <div class="offset-sm-0 offst-1 col-md-4  col-6  input-group mb-3 pl-0 pr-0">
                  <input id="other_floating_device"
                         v-model="form.other_floating_device"
                         :disabled="form.floating_device_id != 4"
                         class="form-control" name="other_floating_device" type="text">
                </div>

              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <label id="has_life_jacket_id" class=" col-lg-4 col-12 ">11. การสวมเสื้อชูชีพ/เสื้อพยุงตัว
              ขณะเกิดเหตุ</label>
            <div class="offset-lg-0 col-md-1 offset-1 col-2">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="has_life_jacket2" v-model="form.has_life_jacket_id"
                       class="custom-control-input" name="has_life_jacket"
                       type="radio"
                       value="2">
                <label class="custom-control-label" for="has_life_jacket2">ไม่มี</label>
              </div>
            </div>
            <div class="offset-1 col-md-2 col-5">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="has_life_jacket1" v-model="form.has_life_jacket_id"
                       class="custom-control-input" name="has_life_jacket"
                       type="radio"
                       value="1">
                <label class="custom-control-label" for="has_life_jacket1">มี</label>
              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <label id="risk_factors_id" class="col-12 ">12. ปัจจัยเสี่ยง/พฤติกรรมเสี่ยงต่อการเกิดเหตุ (ตอบได้มากกว่า 1
              ข้อ)</label>
            <div class="offset-1 col-lg-3 col-md-5 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor1" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="1">
                <label class="custom-control-label" for="risk_factor1">ขาดการดูแล</label>
              </div>
            </div>
            <div class="offset-lg-0 offset-md-0 offset-1 col-lg-4 col-md-6 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor2" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="2">
                <label class="custom-control-label"
                       for="risk_factor2">ขาดความรู้เรื่องแหล่งน้ำเสี่ยง</label>
              </div>
            </div>
            <div class="offset-lg-0 offset-1  col-lg-4 col-md-5  col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor3" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="3">
                <label class="custom-control-label" for="risk_factor3">วิถีชีวิต
                  (ซักล้าง/ตกปลา/เก็บหอย/เก็บผัก)</label>
              </div>
            </div>
            <div class="offset-lg-1 offset-md-0 offset-1 col-lg-3 col-md-6  col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor4" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="4">
                <label class="custom-control-label" for="risk_factor4">ดื่มแอลกอฮอล์</label>
              </div>
            </div>
            <div class="offset-lg-0 offset-md-1 offset-1 col-lg-4 col-md-5 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor5" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="5">
                <label class="custom-control-label" for="risk_factor5">การใช้ยารักษาโรค</label>
              </div>
            </div>
            <div class="offset-md-0 offset-1  col-lg-4 col-md-5  col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor6" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="6">
                <label class="custom-control-label" for="risk_factor6">มีโรคประจำตัว</label>
              </div>
            </div>
            <div class="offset-lg-1 offset-md-1 offset-1 col-lg-3 col-md-5  col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor7" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="7">
                <label class="custom-control-label" for="risk_factor7">ทุพพลภาพ</label>
              </div>
            </div>
            <div class="offset-md-0 offset-1  col-lg-4 col-md-5  col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor8" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="8">
                <label class="custom-control-label" for="risk_factor8">สภาพภูมิอากาศ</label>
              </div>
            </div>
            <div class="offset-lg-0 offset-md-1 offset-1 col-lg-4 col-md-5 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor9" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="9">
                <label class="custom-control-label" for="risk_factor9">กระแสน้ำที่รุนแรง</label>
              </div>
            </div>
            <div class="offset-lg-1 offset-md-0 offset-1 col-lg-3 col-md-6  col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor11" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="11">
                <label class="custom-control-label" for="risk_factor11">พฤติกรรมคนขับเรือ</label>
              </div>
            </div>
            <div class="offset-lg-0 offset-1  col-lg-4 col-md-5  col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor10" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="10">
                <label class="custom-control-label" for="risk_factor10">เรือไม่ปลอดภัย (เช่น
                  การบรรทุกน้ำหนักเกิน)</label>
              </div>

            </div>
            <div class="offset-md-0 offset-1  col-lg-4 col-md-5  col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor12" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="12">
                <label class="custom-control-label" for="risk_factor12">แหล่งน้ำไม่ปลอดภัย (เช่น
                  ขาดการสร้างรั้ว/พื้นผิวลื่น)</label>
              </div>
            </div>
            <div class="offset-1 col-lg-3 col-md-6  col-11 pt-xl-1">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="risk_factor13" v-model="form.risk_factors_id"
                       class="custom-control-input" type="checkbox"
                       value="13">
                <label class="custom-control-label"
                       for="risk_factor13">ขาดระบบการแจ้งเตือนภัยล่วงหน้า</label>
              </div>
            </div>

            <div class="offset-lg-0 offset-1  col-lg-6 row">
              <div class=" col-sm-4 col-11 col-form-label custom-control custom-checkbox custom-checkbox">
                <input id="other_risk_factor" v-model="form.risk_factors_id"
                       class="custom-control-input"
                       name="activity_people_with_patient"
                       type="checkbox"
                       value="14"
                       @change="clearRiskFactor">
                <label class="custom-control-label"
                       for="other_risk_factor">
                  อื่นๆ โปรดระบุ
                </label>
              </div>
              <div class="offset-sm-0 offst-1 col-md-4  col-6  input-group mb-3 pl-0 pr-0">
                <input id="other_risk_factors"
                       v-model="form.other_risk_factors"
                       :disabled="form.other_risk_factors != null && !form.risk_factors_id.includes('14')"
                       class="form-control" name="other_risk_factor" type="text">

              </div>
            </div>

          </div>

          <div class="mt-3 form-group">
            <div class="row">
              <label id="patient_status_die" class="col-md-3 col-12 mb-0">13. หลังเกิดเหตุจมน้ำ</label>

              <div v-if="form.alive == 1" class="offset-lg-0 offset-md-0 offset-1
                                        col-lg-3 col-md-4 col-12 col-form-label pt-0 pb-0 pl-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input
                    id="patient_status1"
                    v-model="form.patient_status_id" class="custom-control-input"
                    type="radio"
                    value="1" @change="clearInjurePatientStatus(1)">
                  <label class="custom-control-label" for="patient_status1">เสียชีวิต ณ
                    ที่เกิดเหตุ</label>
                </div>
              </div>

              <div v-if="form.alive == 1" class="offset-1 offset-lg-0 offset-md-0 pt-0 pb-0
                                    col-lg-3 col-md-4 col-12  row col-form-label pl-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="patient_status2" v-model="form.patient_status_id" class="custom-control-input"
                         type="radio"
                         value="2" @change="clearInjurePatientStatus(2)">
                  <label class="custom-control-label"
                         for="patient_status2">เสียชีวิตขณะนำส่งโรงพยาบาล</label>
                </div>
              </div>
              <label class="col-md-3 col-12 mb-0"></label>
              <label class="col-md-3 col-12 mb-0"></label>
              <div v-if="form.alive == 1" class="offset-lg-0 offset-md-3 offset-1 col-lg-3 pt-0 pb-0
                                      col-md-4 col-12 col-form-label pl-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="patient_status3" v-model="form.patient_status_id" class="custom-control-input"
                         type="radio"
                         value="3" @change="clearInjurePatientStatus(3)">
                  <label class="custom-control-label" for="patient_status3">เสียชีวิต ณ
                    ห้องฉุกเฉิน </label>
                </div>
              </div>
              <div v-if="form.alive == 1" class="offset-lg-0 offset-md-3 offset-1 col-lg-3 pt-0 pb-0
                                      col-md-4 col-12 col-form-label pl-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="patient_status4" v-model="form.patient_status_id" class="custom-control-input"
                         type="radio"
                         value="4" @change="clearInjurePatientStatus(4)">
                  <label class="custom-control-label" for="patient_status4">เสียชีวิตหลังรับไว้รักษา </label>
                </div>
              </div>


              <div v-if="form.patient_status_id === 2 || form.patient_status_id === 3 || form.patient_status_id === 4"
                   class="mt-3 row">
                <div id="date_of_illness" class="col-lg-4 col-md-6 col-12 form-group row">
                  <label class="col-lg-5 col-md-5 col-4 col-form-label">วันที่เริ่มมีอาการ</label>
                  <div class="col-lg-6 col-md-7 col-6">
                    <date-picker id="date_of_illness"
                                 v-model="form.date_of_illness"
                                 :format="changeFormat"
                                 :lang="lang"
                                 type="date"
                                 width="100%"
                                 @focus="initDate(form.date_of_illness)"
                                 @calendar-change="convertYear">
                    </date-picker>
                  </div>
                </div>
                <div id="date_of_treat" class="col-lg-4 col-md-6 col-12 form-group row">
                  <label class="col-lg-5 col-md-5 col-4 col-form-label">วันที่รักษาวันแรก</label>
                  <div class="col-lg-6 col-md-7 col-6">
                    <date-picker id="date_of_treat"
                                 ref="datePicker"
                                 v-model="form.date_of_treat"
                                 :format="changeFormat"
                                 :lang="lang"
                                 type="date"
                                 width="100%"
                                 @focus="initDate(form.date_of_treat)"
                                 @calendar-change="convertYear">
                    </date-picker>
                  </div>
                </div>

                <!--                      v-if="form.patient_status_id === 1 || form.patient_status_id === 2 || form.patient_status_id === 3 || form.patient_status_id === 4"-->
                <div id="date_of_death1" class="col-lg-4 col-md-6 col-12 form-group row">
                  <label class="col-lg-5 col-md-5 col-4 col-form-label">วันที่เสียชีวิต</label>
                  <div class="col-lg-6 col-md-7 col-6">
                    <date-picker id="date_of_death1"
                                 ref="datePicker"
                                 v-model="form.date_of_death"
                                 :format="changeFormat"
                                 :lang="lang"
                                 type="date"
                                 width="100%"
                                 @focus="initDate(form.date_of_death)"
                                 @calendar-change="convertYear">
                    </date-picker>
                  </div>
                </div>
              </div>


              <div v-if="form.patient_status_id === 1" class="mt-3 row">
                <div id="date_of_death2" class="col-12 form-group row">
                  <label class="col-lg-5 col-md-5 col-4 col-form-label">วันที่เสียชีวิต</label>
                  <div class="col-lg-6 col-md-7 col-6">
                    <date-picker id="date_of_death2"
                                 ref="datePicker"
                                 v-model="form.date_of_death"
                                 :format="changeFormat"
                                 :lang="lang"
                                 type="date"
                                 width="100%"
                                 @focus="initDate(form.date_of_death)"
                                 @calendar-change="convertYear">
                    </date-picker>
                  </div>
                </div>
              </div>


              <div v-if="form.alive == 2 || form.alive == 3" class="offset-1 col-lg-4 col-md-5
                                    col-12 row col-form-label pt-0 pl-0">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="patient_status5" v-model="form.patient_status_id" class="custom-control-input"
                         type="radio"
                         value="5" @change="clearInjurePatientStatus(5)">
                  <label id="patient_status_alive" class="custom-control-label" for="patient_status5">ไม่เสียชีวิต
                    รับไว้รักษา</label>
                </div>
              </div>
            </div>

            <div v-if="form.alive == 2 || form.alive == 3" id="injure_patient_status_id" class="row pl-5">
              <div class="pl-4 offset-sm-1 col-lg-3 col-md-4 row">
                <div class=" custom-control custom-checkbox custom-checkbox">
                  <input id="injure_patient_status1"
                         v-model="form.injure_patient_status_id" :disabled="form.patient_status_id != 5"
                         class="custom-control-input"
                         type="radio"
                         value="1"
                         @click="injurePatientStatusId">
                  <label class="custom-control-label"
                         for="injure_patient_status1">
                    ผู้ป่วยนอก (OPD)
                  </label>
                </div>
              </div>
              <div class="pt-0 pb-0 pl-4 offset-sm-1  col-lg-4
                                        col-md-4 col-11 row ">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="injure_patient_status2"
                         v-model="form.injure_patient_status_id" :disabled="form.patient_status_id != 5"
                         class="custom-control-input"
                         type="radio"
                         value="2"
                         @click="injurePatientStatusId">
                  <label class="custom-control-label"
                         for="injure_patient_status2">
                    ผู้ป่วยใน (IPD)
                  </label>
                </div>
              </div>

              <div class="pl-4 offset-sm-1 col-lg-8 col-11 row">
                <div class=" custom-control custom-checkbox col-lg-3 col-md-4 col-12 col-form-label">
                  <input id="injure_patient_status3"
                         v-model="form.injure_patient_status_id" :disabled="form.patient_status_id != 5"
                         class="custom-control-input"
                         type="radio"
                         value="3">
                  <label class="custom-control-label"
                         for="injure_patient_status3">
                    การส่งต่อ (refer) ระบุ
                  </label>
                </div>
                <div class="input-group col-lg-6 col-md-5 col-8">
                  <input v-model="form.other_injure_patient_status"
                         :disabled="form.injure_patient_status_id!=3"
                         class="form-control" name="other_injure_patient_status" type="text">
                </div>
              </div>
            </div>

            <template v-if="form.alive == 2 || form.alive == 3">
              <div class="mt-3 row">
                <div class="pl-0 col-lg-4 col-md-6 col-12 offset-1 form-group row">
                  <label class="col-lg-6 col-md-5 col-4 col-form-label">วันที่เริ่มมีอาการ</label>
                  <div class="col-lg-6 col-md-7 col-6">
                    <date-picker id="date_of_illness"
                                 ref="datePicker"
                                 v-model="form.date_of_illness"
                                 :format="changeFormat"
                                 :lang="lang"
                                 type="date"
                                 width="100%"
                                 @focus="initDate(form.date_of_illness)"
                                 @calendar-change="convertYear">
                    </date-picker>
                    <!--                            <date-picker v-model="form.date_of_illness"-->
                    <!--                                         id="date_of_illness"-->
                    <!--                                         :lang="lang"-->
                    <!--                                         type="date"-->
                    <!--                                         :not-after="new Date()"-->
                    <!--                                         ref="datePicker"-->
                    <!--                                         format="D-MM-YYYY"-->
                    <!--                                         width="100%">-->
                    <!--                            </date-picker>-->
                  </div>
                </div>
                <div class="pl-0 col-lg-4 col-md-6 col-12  offset-1 form-group row">
                  <label class="col-lg-6 col-md-5 col-4 col-form-label">วันที่รักษาวันแรก</label>
                  <div class="col-lg-6 col-md-7 col-6">
                    <date-picker id="date_of_treat"
                                 ref="datePicker"
                                 v-model="form.date_of_treat"
                                 :format="changeFormat"
                                 :lang="lang"
                                 type="date"
                                 width="100%"
                                 @focus="initDate(form.date_of_treat)"
                                 @calendar-change="convertYear">
                    </date-picker>
                  </div>
                </div>
              </div>

            </template>
            <div v-if="form.alive == 2 || form.alive == 3" class="pt-2 offset-1 col-lg-5 col-md-6
                                    col-12 row col-form-label pt-0 pl-0">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="patient_status6" v-model="form.patient_status_id" class="custom-control-input"
                       type="radio"
                       value="6" @change="clearInjurePatientStatus(6)">
                <label id="patient_status_alive" class="custom-control-label" for="patient_status6">ไม่เสียชีวิตและไม่ได้เข้ารับการรักษาในโรงพยาบาล</label>
              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <label id="rescuer_id" class="col-12">14. คนจมน้ำได้รับการช่วยเหลือขึ้นมาจากน้ำโดยใคร (ตอบได้มากกว่า 1
              ข้อ)</label>
            <div class="offset-1 col-lg-3 col-sm-5 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="rescuer1" v-model="form.rescuer_id"
                       class="custom-control-input" name="rescuer"
                       type="checkbox"
                       value="1">
                <label class="custom-control-label" for="rescuer1">ผู้อยู่ในเหตุการณ์</label>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 offset-sm-0 offset-1 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="rescuer2" v-model="form.rescuer_id"
                       class="custom-control-input" name="rescuer"
                       type="checkbox"
                       value="2">
                <label class="custom-control-label"
                       for="rescuer2">ผู้ช่วยเหลือที่ไม่ได้อยู่ในเหตุการณ์</label>
              </div>
            </div>
          </div>

          <div class="mt-3 row">
            <label id="type_help_id" class="col-12">15. ผู้ช่วยเหลือ (ตามข้อ 14) ช่วยขึ้นมาจากน้ำด้วยวิธีใด
              (ตอบได้มากกว่า 1 ข้อ)</label>
            <div class="offset-1 col-lg-3 col-sm-5 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="type_help1" v-model="form.type_help_id"
                       class="custom-control-input" name="type_help"
                       type="checkbox"
                       value="1">
                <label class="custom-control-label" for="type_help1">ตะโกนเรียกคนมาช่วย</label>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6 offset-sm-0 offset-1 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="type_help2" v-model="form.type_help_id"
                       class="custom-control-input" name="type_help"
                       type="checkbox"
                       value="2">
                <label class="custom-control-label" for="type_help2">ช่วยด้วยการกระโดดลงไปช่วย</label>
              </div>
            </div>
            <div class="offset-1 col-11 row">
              <div class="col-lg-5 col-11 pl-0 pr-0">
                <div class="col-form-label custom-control custom-checkbox custom-checkbox">
                  <input id="type_help3" v-model="form.type_help_id"
                         class="custom-control-input"
                         name="type_help" type="checkbox"
                         value="3"
                         @change="clearTypeHelp">
                  <label class="custom-control-label " for="type_help3">ช่วยด้วยการหาอุปกรณ์โยนให้จับ (ระบุอุปกรณ์)
                    โปรดระบุ</label>
                </div>
              </div>
              <div class="col-lg-4 offset-lg-0 offset-1 col-8 input-group mb-3 pl-0 pr-0">
                <input id="throwing_tool"
                       v-model="form.throwing_tool"
                       :disabled="form.type_help_id!= null &&  !form.type_help_id.includes('3')"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="offset-1 col-11 row">
              <div class="col-lg-5 col-11 pl-0 pr-0">
                <div class="col-form-label custom-control custom-checkbox custom-checkbox">
                  <input id="type_help4" v-model="form.type_help_id"
                         class="custom-control-input"
                         name="type_help" type="checkbox"
                         value="4"
                         @change="clearTypeHelp">
                  <label class="custom-control-label " for="type_help4">ช่วยด้วยการหาอุปกรณ์ยื่นให้จับ
                    (ระบุอุปกรณ์) โปรดระบุ</label>
                </div>
              </div>
              <div class="col-lg-4 offset-lg-0 offset-1 col-8 input-group mb-3 pl-0 pr-0">
                <input id="hand_tool"
                       v-model="form.hand_tool"
                       :disabled="form.type_help_id!= null && !form.type_help_id.includes('4')"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="offset-1 col-lg-4 col-sm-6 col-11 col-form-label">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="type_help5" v-model="form.type_help_id"
                       class="custom-control-input" name="type_help"
                       type="checkbox"
                       value="5">
                <label class="custom-control-label" for="type_help5">นำศพขึ้นมาจากน้ำ
                  เนื่องจากเสียชีวิตแล้ว</label>
              </div>
            </div>
            <div class="offset-1 col-11 row">
              <div class="col-lg-2 col-11 pl-0 pr-0">
                <div class="col-form-label custom-control custom-checkbox custom-checkbox">
                  <input id="other_type_help" v-model="form.type_help_id"
                         class="custom-control-input"
                         name="type_help" type="checkbox"
                         value="6"
                         @change="clearTypeHelp">
                  <label class="custom-control-label " for="other_type_help">อื่นๆ โปรดระบุ</label>
                </div>
              </div>
              <div class="col-lg-5 offset-lg-0 offset-1 col-8 input-group mb-3 pl-0 pr-0">
                <input id="other_type_help"
                       v-model="form.other_type_help"
                       :disabled="form.type_help_id!= null && !form.type_help_id.includes('6')"
                       class="form-control" type="text">

              </div>
            </div>
            <label class="offset-1 col-xl-4 col-lg-5 col-md-7 col-11 col-form-label ">ระยะเวลาตั้งแต่มีคนจมน้ำจนกระทั่งมีผู้มาช่วยเหลือใช้ระยะเวลา</label>
            <div class="offset-md-0 col-lg-5 offset-2 col-md-3 col-sm-5 col-8 pl-0 row form-group">

              <div class="col-lg-3 col-8 form-group">
                <input id="drowning_time_hr" v-model.number="form.drowning_time_hr" class="form-control" min="0"
                       type="number">
              </div>
              <label class="col-lg-3 col-4 col-form-label">ชั่วโมง</label>

              <div class="col-lg-3 col-8 form-group">
                <input id="drowning_time" v-model.number="form.drowning_time" class="form-control" min="0"
                       type="number">
              </div>
              <label class="col-lg-3 col-4 col-form-label">นาที</label>

            </div>
          </div>

          <div class="mt-3 row">
            <label id="has_first_aid_id" class="col-12">16. ภายหลังจากช่วยเหลือขึ้นมาจากน้ำ
              ได้รับการปฐมพยาบาลอย่างไร</label>
            <div class="offset-1 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="has_first_aid1" v-model="form.has_first_aid_id"
                       class="custom-control-input"
                       name="has_first_aid" type="radio"
                       value="1"
                       @change="clearFirstAid">
                <label id="reason_not_first_aid_id" class="custom-control-label" for="has_first_aid1">
                  ไม่ได้ทำการปฐมพยาบาล เนื่องจาก
                </label>
              </div>
            </div>
            <div class="offset-2 col-10 row pl-0">
              <div class="col-lg-4 col-md-6 col-11">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="reason_not_first_aid1" v-model="form.reason_not_first_aid_id[0]"
                         :disabled="form.has_first_aid_id != 1"
                         class="custom-control-input" name="reason_not_first_aid"
                         type="radio"
                         value="1">
                  <label class="custom-control-label" for="reason_not_first_aid1">ปฐมพยาบาลไม่เป็น/ไม่รู้วิธี </label>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-11">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="reason_not_first_aid2" v-model="form.reason_not_first_aid_id[0]"
                         :disabled="form.has_first_aid_id != 1"
                         class="custom-control-input" name="reason_not_first_aid"
                         type="radio"
                         value="2">
                  <label class="custom-control-label"
                         for="reason_not_first_aid2">ผู้ป่วยเสียชีวิต</label>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-11">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="reason_not_first_aid3" v-model="form.reason_not_first_aid_id[0]"
                         :disabled="form.has_first_aid_id != 1"
                         class="custom-control-input" name="reason_not_first_aid"
                         type="radio"
                         value="3">
                  <label class="custom-control-label"
                         for="reason_not_first_aid3">ไม่ได้รับบาดเจ็บ</label>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-11">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="reason_not_first_aid4" v-model="form.reason_not_first_aid_id[0]"
                         :disabled="form.has_first_aid_id != 1"
                         class="custom-control-input" name="reason_not_first_aid"
                         type="radio"
                         value="4">
                  <label class="custom-control-label"
                         for="reason_not_first_aid4">อื่นๆ โปรดระบุ
                  </label>
                </div>
              </div>
              <div class="col-lg-8 col-md-9  col-sm-12 col-6 input-group mb-3 pl-0 pr-0">
                <input v-model="form.other_reason_not_first_aid"
                       :disabled="form.reason_not_first_aid_id != null && (form.has_first_aid_id != 1 || !form.reason_not_first_aid_id.includes('4'))"
                       class="form-control" type="text">
              </div>
            </div>
            <div class="offset-1 col-11">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="has_first_aid2" v-model="form.has_first_aid_id"
                       class="custom-control-input"
                       name="has_first_aid" type="radio"
                       value="2"
                       @change="clearFirstAid">
                <label id="type_people_first_aid_id" class="custom-control-label" for="has_first_aid2">
                  ทำการปฐมพยาบาล โดย
                </label>
              </div>
            </div>
            <div class="offset-2 col-10 row pl-0">
              <div class="col-lg-4 col-md-6 col-11">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_people_first_aid1" v-model="form.type_people_first_aid_id[0]"
                         :disabled="form.has_first_aid_id != 2"
                         class="custom-control-input"
                         type="radio" value="1"
                         @change="clearFirstAid">
                  <label class="custom-control-label" for="type_people_first_aid1">ญาติ/ผู้พบเห็นเหตุการณ์</label>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-11">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_people_first_aid2" v-model="form.type_people_first_aid_id[0]"
                         :disabled="form.has_first_aid_id != 2"
                         class="custom-control-input"
                         type="radio" value="2"
                         @change="clearFirstAid">
                  <label class="custom-control-label" for="type_people_first_aid2">หน่วยกู้ชีพ
                    (ALS,BLS,FR)</label>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-11">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_people_first_aid3" v-model="form.type_people_first_aid_id[0]"
                         :disabled="form.has_first_aid_id != 2"
                         class="custom-control-input"
                         type="radio" value="3"
                         @change="clearFirstAid">
                  <label class="custom-control-label" for="type_people_first_aid3">มูลนิธิ/
                    กู้ชีพที่ไม่ได้ขึ้นทะเบียน</label>
                </div>
              </div>
              <div class="col-lg-8 col-11 row">
                <div class="col-md-4 col-sm-5 col-11 col-form-label">
                  <div class="custom-control custom-checkbox custom-checkbox">
                    <input id="other_type_people_first_aid" v-model="form.type_people_first_aid_id[0]"
                           :disabled="form.has_first_aid_id != 2"
                           class="custom-control-input"
                           type="radio" value="4"
                           @change="clearFirstAid">
                    <label class="custom-control-label" for="other_type_people_first_aid">อื่นๆ
                      โปรดระบุ</label>
                  </div>
                </div>
                <div class="col-md-5 offset-md-0 offset-md-2  col-sm-7 col-8 input-group mb-3 pl-0 pr-0">
                  <input v-model="form.other_type_people_first_aid"
                         :disabled="form.type_people_first_aid_id !=null && (form.has_first_aid_id != 2 || !form.type_people_first_aid_id.includes('4'))"
                         class="form-control" type="text">
                </div>
              </div>
            </div>
            <label id="type_first_aid_id" class="offset-1 col-11" style="padding-left: 2.5rem">วิธีปฐมพยาบาล
              (ตอบได้มากกว่า 1
              ข้อ)</label>
            <div class="offset-2 col-10 row pl-0 row">
              <div class="col-md-3 col-sm-6 col-12">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_first_aid1" v-model="form.type_first_aid_id"
                         :disabled="form.has_first_aid_id != 2"
                         class="custom-control-input" type="checkbox"
                         value="1">
                  <label class="custom-control-label" for="type_first_aid1">เป่าปาก</label>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 col-12">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_first_aid2" v-model="form.type_first_aid_id"
                         :disabled="form.has_first_aid_id != 2"
                         class="custom-control-input" type="checkbox"
                         value="2">
                  <label class="custom-control-label" for="type_first_aid2">อุ้มพาดบ่า</label>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 col-12">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_first_aid3" v-model="form.type_first_aid_id"
                         :disabled="form.has_first_aid_id != 2"
                         class="custom-control-input" type="checkbox"
                         value="3">
                  <label class="custom-control-label" for="type_first_aid3">กดหน้าอก</label>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 col-12">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_first_aid4" v-model="form.type_first_aid_id"
                         :disabled="form.has_first_aid_id != 2"
                         class="custom-control-input" type="checkbox"
                         value="4">
                  <label class="custom-control-label" for="type_first_aid4">กระแทกท้อง</label>
                </div>
              </div>

              <div class="col-lg-4 col-md-5 col-sm-4 col-11 col-form-label">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="other_type_first_aid" v-model="form.type_first_aid_id"
                         :disabled="form.has_first_aid_id != 2"
                         class="custom-control-input"
                         type="checkbox" value="5"
                         @change="clearTypeFirstAid">
                  <label class="custom-control-label" for="other_type_first_aid">อื่นๆ
                    โปรดระบุ</label>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 offset-sm-0 offset-1 col-6 input-group mb-3 pl-0 pr-0">
                <input id="other_type_first_aid_id"
                       v-model="form.other_type_first_aid_id"
                       :disabled="form.type_first_aid_id != null && !form.type_first_aid_id.includes('5') "
                       class="form-control" type="text">

              </div>
            </div>

          </div>

          <div class="mt-3 row">
            <label id="has_type_deliver_id" class="col-12">17.
              การนำส่งสถานบริการสาธารณสุขหลังจากได้รับการปฐมพยาบาล</label>
            <div class="offset-1 col-xl-3 col-lg-4 col-md-5 col-11 ">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="has_deliver1" v-model="form.has_type_deliver_id"
                       class="custom-control-input"
                       name="has_deliver" type="radio"
                       value="1"
                       @change="clearDeliver">
                <label class="custom-control-label"
                       for="has_deliver1">ไม่ได้นำส่งสถานบริการสาธารณสุข</label>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 offset-md-0 offset-1 col-11 pl-md-0">
              <div class="custom-control custom-checkbox custom-checkbox">
                <input id="has_deliver2" v-model="form.has_type_deliver_id"
                       class="custom-control-input" name="has_deliver"
                       type="radio"
                       value="2">
                <label id="type_deliver_id" class="custom-control-label" for="has_deliver2">นำส่งสถานบริการสาธารณสุข
                  โดย</label>
              </div>
            </div>
            <div class="offset-xl-4 offset-lg-5 offset-md-6 offset-2 col-xl-8 col-lg-7 col-md-6 col-10 row">
              <div class="col-xl-4">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_deliver1" v-model="form.type_deliver_id"
                         :disabled="form.has_type_deliver_id != 2"
                         class="custom-control-input"
                         name="type_deliver" type="radio"
                         value="1"
                         @change="clearDeliver">
                  <label class="custom-control-label"
                         for="type_deliver1">หน่วยบริการการแพทย์ฉุกเฉิน</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_deliver2" v-model="form.type_deliver_id"
                         :disabled="form.has_type_deliver_id != 2"
                         class="custom-control-input"
                         name="type_deliver" type="radio"
                         value="2"
                         @change="clearDeliver">
                  <label class="custom-control-label" for="type_deliver2">เจ้าหน้าที่มูลนิธิ</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_deliver3" v-model="form.type_deliver_id"
                         :disabled="form.has_type_deliver_id != 2"
                         class="custom-control-input"
                         name="type_deliver" type="radio"
                         value="3"
                         @change="clearDeliver">
                  <label class="custom-control-label" for="type_deliver3">ตำรวจ</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="custom-control custom-checkbox custom-checkbox">
                  <input id="type_deliver4" v-model="form.type_deliver_id"
                         :disabled="form.has_type_deliver_id != 2"
                         class="custom-control-input"
                         name="type_deliver" type="radio"
                         value="4"
                         @change="clearDeliver">
                  <label class="custom-control-label" for="type_deliver4">ญาติ
                    ผู้เห็นเหตุการณ์</label>
                </div>
              </div>
              <!--              <div class="col-xl-4">-->
              <!--                <div class="custom-control custom-checkbox custom-checkbox">-->
              <!--                  <input v-model="form.type_deliver_id" value="6"-->
              <!--                         :disabled="form.has_type_deliver_id != 2"-->
              <!--                         @change="clearDeliver"-->
              <!--                         type="radio" class="custom-control-input"-->
              <!--                         id="type_deliver6"-->
              <!--                         name="type_deliver">-->
              <!--                  <label class="custom-control-label" for="type_deliver6">ไม่ทราบผู้นำส่ง</label>-->
              <!--                </div>-->
              <!--              </div>-->
              <!--              <div class="col-xl-4">-->
              <!--                <div class="custom-control custom-checkbox custom-checkbox">-->
              <!--                  <input v-model="form.type_deliver_id" value="7"-->
              <!--                         :disabled="form.has_type_deliver_id != 2"-->
              <!--                         @change="clearDeliver"-->
              <!--                         type="radio" class="custom-control-input"-->
              <!--                         id="type_deliver7"-->
              <!--                         name="type_deliver">-->
              <!--                  <label class="custom-control-label" for="type_deliver7">มาจากสถานพยาบาลอื่น</label>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="col-xl-3 col-md-6 col-sm-5 col-12">
                <div class="col-form-label custom-control custom-checkbox custom-checkbox">
                  <input id="other_type_deliver" v-model="form.type_deliver_id"
                         :disabled="form.has_type_deliver_id != 2"
                         class="custom-control-input"
                         name="type_deliver" type="radio"
                         value="5"
                         @change="clearDeliver">
                  <label class="custom-control-label" for="other_type_deliver">อื่นๆ โปรดระบุ</label>
                </div>
              </div>
              <div class="col-md-4 offset-sm-0 col-sm-5 offset-2 col-6 input-group mb-3 pl-0 pr-0">
                <input id="other_deliver_type"
                       v-model="form.other_deliver_type"
                       :disabled="form.has_type_deliver_id != 2 || form.type_deliver_id != 5 && form.type_deliver_id != null"
                       class="form-control" type="text">
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="mt-5 text-center">
        <b-button class="btn-submit"
                  @click="savePatient">
          บันทึก
        </b-button>
      </div>
    </form>


    <!--        <pre class="alert-success">{{form.caregiver_id.length == 0}}</pre>-->
    <!--          <pre class="alert-success">{{form}}</pre>-->
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker/lib/datepicker.js'
import Multiselect from 'vue-multiselect'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'DrowningForm',
  props: {
    id: { default: null },
    order: { default: null },
  },
  components: {
    DatePicker,
    Multiselect,
  },
  created () {
    console.log('form.id', this.form.id)
    this.$store.dispatch('Common/setProvincePatient')
    this.$store.dispatch('Common/setNation')

    console.log("Created",this.event_form)
    console.log("this.form",this.form)

    if (!this.form.id) {
      if (!this.form.date_of_illness || this.form.date_of_illness == '') {
        this.form.date_of_illness = this.event_form.date_of_event
      }
      if (!this.form.date_of_treat) {
        this.form.date_of_treat = this.event_form.date_of_event
      }
      if (!this.form.date_of_death) {
        this.form.date_of_death = this.event_form.date_of_event
      }
    }

  },
  mounted() {
    console.log("this.form mounted",this.form)
  },
  updated () {
    console.log('Patient...', this.form)
    console.log('Event...', this.event_form)
    if (!this.form.id) {
      if (!this.form.date_of_illness) {
        this.form.date_of_illness = this.event_form.date_of_event
      }
      if (!this.form.date_of_treat) {
        this.form.date_of_treat = this.event_form.date_of_event
      }
      if (!this.form.date_of_death) {
        this.form.date_of_death = this.event_form.date_of_event
      }
    }
  },
  computed: {
    ...mapState({
      form: state => {
        return state.Patient.form
      },
      event_form: state => {
        return state.Event.form
      },
      optionProvince: state => {
        return state.Common.province_patient
      },
      optionDistrict: state => {
        return state.Common.districts
      },
      optionSubDistrict: state => {
        return state.Common.sub_districts
      },
      optionNationality: state => {
        return state.Common.nations_code
      }
    })
  },
  data () {
    return {
      patientTitleOptions: ['เด็กชาย', 'เด็กหญิง', 'นาย', 'นาง', 'นางสาว', 'อื่นๆ'],
      changeFormat: {
        stringify: (date) => {
          return date ? moment(date).add(543, 'y').format('DD-MM-YYYY') : null
        },
        parse: (value) => {
          return value ? moment(value, 'DD-MM-YYYY').subtract(543, 'y').toDate() : null
        }
      },
      lang: {
        days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
        placeholder: {
          date: 'วว/ดด/ปปปป'
        }
      }
    }
  },
  methods: {

    // Convert 2020 to 2563
    initDate (date) {
      const d = new Date(date)
      if (Object.prototype.toString.call(d) === '[object Date]') {
        // it is a date
        if (isNaN(d.getTime())) {  // d.valueOf() could also work
          // date is not valid
          date = new Date()
        } else {
          // date is valid
          date = new Date(date)
        }
      } else {
        // not a date
        date = new Date()
      }
      this.convertYear(date)
    },
    convertYear (date, oldDate, type) {
      const calendarYear = date.getFullYear()
      for (const item of document.getElementsByClassName('mx-current-year')) {
        item.href = '#'
        const innerHTML = item.innerHTML
        const innerHTMLsplit = innerHTML.split(' ~ ')
        if (innerHTMLsplit.length === 2) {
          item.innerHTML = `${(calendarYear - 9) + 543} ~ ${calendarYear + 543}`
        } else {
          item.innerHTML = `${calendarYear + 543}`
        }
      }
    },
    onClickAlive (id) {
      switch (id) {
        case 1:
          this.form.patient_status_id = '5'
          this.form.alive = id
          break
        case 2:
          this.form.patient_status_id = '5'
          this.form.alive = id
          break
        case 3:
          this.form.patient_status_id = '6'
          this.form.alive = id
          break
      }
      // console.log(this.form.alive)
    },
    showErrorFill (element, message) {
      this.$scrollTo(element, 1000, { easing: 'ease', cancelable: false, offset: -100 })
      const Toast = this.$swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        type: 'error',
        title: message
      })
    },
    showSavePatientFill (message) {
      // const Toast = this.$swal.fire(
      //     'บันทึกเรียบร้อย',
      // )
      const Toast = this.$swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        type: 'success',
        title: 'บันทึกเรียบร้อย'
      })
    },
    getDistricts (province) {
      if (province) {
        this.form.location_district = null
        this.form.location_sub_district = null

        this.$store.dispatch('Common/setDistrict', province.code)
      }
    },
    getSubDistricts (district) {
      if (district) {
        this.form.location_sub_district = null
        // this.form.location_district = null;
        // this.form.location_district = null;
        this.$store.dispatch('Common/setSubDistrict', district.district_id)
      }
    },
    clearInjurePatientStatus (val) {
      this.form.patient_status_id = val
      // console.log(this.form.patient_status_id)
      if (val === 1) {
        this.form.date_of_illness = this.event_form.date_of_event
        this.form.date_of_treat = this.event_form.date_of_event
        this.form.date_of_death = this.event_form.date_of_event
      } else {
        this.form.date_of_death = this.event_form.date_of_event
      }

      if (this.form.patient_status_id === 5 || this.form.patient_status_id === 6) {
        this.form.injure_patient_status_id = ''
        this.form.other_injure_patient_status = ''
      }
    },
    clearDataStatus () {
      if (this.form.alive == 1) {
        this.form.patient_status_id = ''
        this.form.other_injure_patient_status = ''
        this.injure_patient_status_id = ''
        this.other_injure_patient_status = ''
        this.date_of_illness = ''
        this.date_of_treat = ''
      } else {
        this.form.patient_status_id = ''
        this.date_of_illness = ''
        this.date_of_death = ''
        this.date_of_treat = ''
      }
    },
    clearHasFloatingDeviceId () {
      if (this.form.floating_device_id !== 4) {
        this.form.other_floating_device = ''
      }
    },
    clearActivityBeforeEvent () {
      if (this.form.activity_before_event_id != null && !this.form.activity_before_event_id.includes('5')) {
        this.form.other_activity_before_event = ''
      }
    },
    clearDataPerson () {
      if (this.form.unknown_person == 2) {
        this.form.first_name = ''
        this.form.last_name = ''
        this.form.id_number = ''
        this.form.address_no = ''
        this.form.village_no = ''
        this.form.location_province = ''
        this.form.location_district = ''
        this.form.location_sub_district = ''
      }
    },
    clearPeopleWithPatient () {
      if (this.form.people_with_patient_id != 3) {
        this.form.activity_people_with_patient_id = ''
        this.form.other_activity_people_with_patient = ''
      }
    },
    clearFloatingDevice () {
      if (this.form.has_floating_device_id != null && this.form.has_floating_device_id == 2) {
        this.form.floating_device_id = ''
        this.form.other_floating_device = ''
      }
    },
    clearActivity () {
      if (this.form.caregiver_id != null && !this.form.caregiver_id.includes('3')) {
        this.form.other_caregiver = ''
      }
    },
    injurePatientStatusId () {
      if (this.form.injure_patient_status_id !== 3) {
        this.form.other_injure_patient_status = ''
      }
    },
    clearDistance () {
      if (this.form.has_event_at_home_id != null && this.form.has_event_at_home_id) {
        this.form.distance_kilometre = 0
        this.form.distance_metre = 0
      }
    },
    clearRiskFactor () {
      if (this.form.risk_factors_id != null && !this.form.risk_factors_id.includes('14')) {
        this.form.other_risk_factors = ''
      }
    },
    clearTypeHelp () {
      if (this.form.type_help_id != null && this.form.type_help_id == 3) {
        this.form.hand_tool = ''
        this.form.other_type_help = ''
      } else if (this.form.type_help_id != null && this.form.type_help_id == 4) {
        this.form.throwing_tool = ''
        this.form.other_type_help = ''
      } else if (this.form.type_help_id != null && this.form.type_help_id == 6) {
        this.form.throwing_tool = ''
        this.form.hand_tool = ''
      }
    },
    clearFirstAid () {
      if (this.form.has_first_aid_id != null && this.form.has_first_aid_id == 1) {
        this.form.type_people_first_aid_id = []
        this.form.other_type_people_first_aid = ''
        this.form.type_first_aid_id = []
        this.form.other_type_first_aid_id = ''
      }
      if (this.form.has_first_aid_id != null && this.form.has_first_aid_id == 2 && this.form.type_people_first_aid_id != null && !this.form.type_people_first_aid_id.includes('4')) {
        this.form.other_type_people_first_aid = ''
      }
      if (this.form.has_first_aid_id != null && this.form.has_first_aid_id == 2 && this.form.reason_not_first_aid_id != null && !this.form.reason_not_first_aid_id.includes('4')) {
        this.form.other_reason_not_first_aid = ''
      }
      if (this.form.has_first_aid_id != null && this.form.has_first_aid_id == 2) {
        this.form.reason_not_first_aid_id = []
      }
    },
    clearTypeFirstAid () {
      if (this.form.type_first_aid_id != null && !this.form.type_first_aid_id.includes('5')) {
        this.form.other_type_first_aid_id = ''

      }
    },
    clearDeliver () {
      if (this.form.has_type_deliver_id != null && this.form.has_type_deliver_id == 1) {
        this.form.type_deliver_id = ''
        this.form.other_type_deliver = ''
      } else if (this.form.has_type_deliver_id != null && this.form.has_first_aid_id == 2 && this.form.type_people_first_aid_id != 5) {
        this.form.other_deliver_type = ''
      }
    },
    savePatient () {

      if (this.form.unknown_person == '') {
        this.showErrorFill('#unknown_person', 'กรุณาเลือกประเภทรายละเอียดบุคคล')
      } else if (this.form.alive == '') {
        this.showErrorFill('#alive', 'กรุณาเลือกสถานะของบุคคล')
      } else if (this.form.gender_id == '') {
        this.showErrorFill('#gender_id', 'กรุณาเลือกเพศ')
      }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.first_name) {
        //     this.showErrorFill('#first_name', 'กรุณากรอกชื่อจริง');
        // }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.last_name) {
        //     this.showErrorFill('#last_name', 'กรุณากรอกชื่อนามสกุล');
        // }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.id_number) {
        //     this.showErrorFill('#id_number', 'กรุณากรอกเลขบัตรประจำตัวประชาชน');
        // }
        // else if (!this.form.nationality_code) {
        //     this.showErrorFill('#nationality', 'กรุณาเลือกสัญชาติ');
        // }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.address_no) {
        //     this.showErrorFill('#address_no', 'กรุณากรอกเลขที่บ้าน');
        // }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.village_no) {
        //     this.showErrorFill('#village_no', 'กรุณากรอกหมายเลขหมู่บ้าน');
        // }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.location_province) {
        //     this.showErrorFill('#location_province', 'กรุณาเลือกจังหวัด');
        // }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.location_district) {
        //     this.showErrorFill('#location_district', 'กรุณาเลือกอำเภอ');
        // }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.location_sub_district) {
        //     this.showErrorFill('#location_sub_district', 'กรุณาเลือกตำบล');
        // }
        // else if ((this.form.unknown_person == "" || this.form.unknown_person == 1) && !this.form.school) {
        //     this.showErrorFill('#location_sub_district', 'กรุณากรอกชื่อโรงเรียน');
        // }
        // else if (!this.form.gender_id) {
        //     this.showErrorFill('#gender_id', 'กรุณาเลือกเพศ');
        // }
        // else if (this.form.age == '' && this.form.age_month == '') {
        //     this.showErrorFill('#age', 'กรุณาระบุอายุ');
      // }
      else if (this.form.alive == 1 && !this.form.date_of_illness) {
        this.showErrorFill('#date_of_illness', 'กรุณาระบุวันที่เริ่มมีอาการ')
      } else if (this.form.alive == 1 && !this.form.date_of_treat) {
        this.showErrorFill('#date_of_treat', 'กรุณาระบุวันที่รักษาวันแรก')
      } else if (this.form.alive == 1 && !this.form.date_of_death) {
        this.showErrorFill('#date_of_death', 'กรุณาระบุวันที่เสียชีวิต')
      } else if (this.form.alive == 2 && !this.form.date_of_illness) {
        this.showErrorFill('#date_of_death', 'กรุณาระบุวันที่เริ่มมีอาการ')
      } else if (this.form.alive == 2 && !this.form.date_of_treat) {
        this.showErrorFill('#date_of_death', 'กรุณาระบุวันที่รักษาวันแรก')
      } else if (this.form.alive == 1 && (this.form.patient_status_id != 1 && this.form.patient_status_id != 2 && this.form.patient_status_id != 3 && this.form.patient_status_id != 4)) {
        console.log(this.form)
        console.log(1)
        this.showErrorFill('#patient_status_die', 'กรุณาเลือกอาการหลังเกิดเหตุจมน้ำ')
      } else if (this.form.alive == 2 && this.form.patient_status_id != 5 && this.form.patient_status_id != 6) {
        console.log(2)
        this.showErrorFill('#patient_status_alive', 'กรุณาเลือกอาการหลังเกิดเหตุจมน้ำ')
      } else if (this.form.alive == 2 && this.form.patient_status_id == 5 && !this.form.injure_patient_status_id) {
        console.log(3)
        this.showErrorFill('#patient_status_alive', 'กรุณาเลือกอาการหลังเกิดเหตุจมน้ำ')
      } else if (this.form.injure_patient_status_id == 3 && !this.form.other_injure_patient_status) {
        this.showErrorFill('#patient_status_alive', 'กรุณากรอกการส่งต่อ (refer)')
      }
        // else if (this.form.swimming_id != 1 && this.form.swimming_id != 2 && this.form.swimming_id != 3) {
        //     this.showErrorFill('#swimming_id', 'กรุณาเลือกความสามารถในการว่ายน้ำ');
        // }
        // else if (this.form.swimming_ability_id != 1 && this.form.swimming_ability_id != 2 && this.form.swimming_ability_id != 3) {
        //     this.showErrorFill('#swimming_ability_id', 'กรุณาเลือกทักษะการเอาชีวิตรอดในน้ำ');
      // }
      else if (!this.form.people_with_patient_id) {
        this.showErrorFill('#people_with_patient_id', 'กรุณาเลือกบุคคลที่ผู้จมน้ำอยู่ด้วยขณะเกิดเหตุ')
      } else if (!this.form.activity_people_with_patient_id && this.form.people_with_patient_id != '' && this.form.people_with_patient_id == 3) {
        this.showErrorFill('#activity_people_with_patient_id', 'กรุณาเลือกกิจกรรมของบุคคลที่ผู้จมน้ำอยู่ด้วย ทำขณะเกิดเหตุ')
      } else if (!this.form.other_activity_people_with_patient && this.form.people_with_patient_id != '' && this.form.people_with_patient_id == 3 && this.form.activity_people_with_patient_id == '5') {
        this.showErrorFill('#other_activity_people_with_patient', 'กรุณาระบุ กิจกรรมอื่นๆ ของบุคคลที่ผู้จมน้ำอยู่ด้วย ทำขณะเกิดเหตุ')
      } else if (this.form.activity_before_event_id == '') {
        this.showErrorFill('#activity_before_event_id', 'กรุณาเลือกกิจกรรมก่อนเกิดเหตุ')
      } else if (this.form.activity_before_event_id.includes('5') && !this.form.other_activity_before_event) {
        this.showErrorFill('#other_activity_before_event', 'กรุณาระบุกิจกรรมก่อนเกิดเหตุ')
      } else if (this.form.caregiver_id.length == 0) {
        this.showErrorFill('#caregiver_id', 'กรุณาเลือกผู้ดูแลก่อนเกิดเหตุ')
      } else if (!this.form.other_caregiver && this.form.caregiver_id != null && this.form.caregiver_id.includes('3')) {
        this.showErrorFill('#other_caregiver', 'กรุณาระบุผู้ดูแลก่อนเกิดเหตุ')
      } else if ((this.form.distance_kilometre < 0 || this.form.distance_metre < 0) && !this.form.has_event_at_home_id) {
        this.showErrorFill('#distance_kilometre', 'กรุณากรอกระยะห่างระหว่างบ้านและจุดเกิดเหตุให้ถูกต้อง')
      } else if ((this.form.distance_kilometre == 0 && this.form.distance_metre == 0) && !this.form.has_event_at_home_id) {
        this.showErrorFill('#distance_metre', 'กรุณากรอกระยะห่างระหว่างบ้านและจุดเกิดเหตุ')
      } else if (!this.form.has_floating_device_id) {
        this.showErrorFill('#has_floating_device_id', 'กรุณาระบุการใช้อุปกรณ์ช่วยเหลือขณะเกิดเหตุ')
      } else if (this.form.has_floating_device_id == 1 && !this.form.floating_device_id) {
        this.showErrorFill('#floating_device_id', 'กรุณเลือกอุปกรณ์ที่ใช้ช่วยเหลือขณะเกิดเหตุ')
      } else if (this.form.has_floating_device_id == 1 && this.form.floating_device_id == 4 && !this.form.other_floating_device) {
        this.showErrorFill('#other_floating_device', 'กรุณเลือกอุปกรณ์อื่นๆ ที่ใช้ช่วยเหลือขณะเกิดเหตุ')
      }
        // else if (!this.form.has_life_jacket_id) {
        //     this.showErrorFill('#has_life_jacket_id', 'กรุณเลือกการสวมเสื้อชูชีพ/เสื้อพยุงตัว ขณะเกิดเหตุ');
        // }
        // else if (this.form.risk_factors_id.length == 0) {
        //     this.showErrorFill('#risk_factors_id', 'กรุณเลือกปัจจัยเสี่ยง/พฤติกรรมเสี่ยง ต่อการเกิดเหตุ');
      // }
      else if (!this.form.other_risk_factors && this.form.risk_factors_id != null && this.form.risk_factors_id.includes('14')) {
        this.showErrorFill('#other_risk_factors', 'กรุณระบุปัจจัยเสี่ยง/พฤติกรรมเสี่ยงอื่นๆ ต่อการเกิดเหตุ')
      }
        // else if (this.form.rescuer_id.length == 0) {
        //     this.showErrorFill('#rescuer_id', 'กรุณเลือกผู้ช่วยเหลือคนจมน้ำ');
        // }
        // else if (this.form.type_help_id.length == 0) {
        //     this.showErrorFill('#type_help_id', 'กรุณเลือกชิธีการช่วยขึ้นมาจากน้ำด้วยวิธีใด');
      // }
      else if (this.form.type_help_id.length != 0 && this.form.type_help_id.includes('3') && !this.form.throwing_tool) {
        this.showErrorFill('#throwing_tool', 'กรุณาระบุอุปกรณ์ที่ใช้โยนในการช่วยเหลือ')
      } else if (this.form.type_help_id.length != 0 && this.form.type_help_id.includes('4') && !this.form.hand_tool) {
        this.showErrorFill('#hand_tool', 'กรุณาระบุอุปกรณ์ที่ใช้จับในการช่วยเหลือ')
      } else if (this.form.type_help_id.length != 0 && this.form.type_help_id.includes('6') && !this.form.other_type_help) {
        this.showErrorFill('#other_type_help', 'กรุณาระบุอุปกรณ์อื่นๆ ที่ใช้ในการช่วยเหลือ')
      }
        // else if (!this.form.drowning_time && !this.form.drowning_time_hr) {
        //     this.showErrorFill('#drowning_time', 'กรุณาระบุระยะการจมน้ำจนมีผุ้มาช่วยเหลือ');
        // }
        // else if (this.form.drowning_time < 0 || this.form.drowning_time_hr < 0 ) {
        //     this.showErrorFill('#drowning_time', 'กรุณาระบุระยะการจมน้ำจนมีผุ้มาช่วยเหลือให้ถูกต้อง');
      // }
      else if (!this.form.has_first_aid_id) {
        this.showErrorFill('#has_first_aid_id', 'กรุณาเลือกการปฐมพยาบาลว่าได้รับหรือไม่')
      } else if (this.form.has_first_aid_id == 1 && this.form.reason_not_first_aid_id.length == 0) {
        this.showErrorFill('#reason_not_first_aid_id', 'กรุณาเลือกเหตุผลที่ไม่ได้ทำการปฐมพยาบาล')
      } else if (this.form.has_first_aid_id == 2 && this.form.type_people_first_aid_id.length == 0) {
        this.showErrorFill('#type_people_first_aid_id', 'กรุณาเลือกผู้ที่ทำการปฐมพยาบาล')
      } else if (this.form.has_first_aid_id == 2 && this.form.type_people_first_aid_id.includes('4') && !this.form.other_type_people_first_aid) {
        this.showErrorFill('#other_type_people_first_aid', 'กรุณาระบุผู้ที่ทำการปฐมพยาบาล')
      } else if (this.form.has_first_aid_id == 2 && this.form.reason_not_first_aid_id.includes('4') && !this.form.other_reason_not_first_aid) {
        this.showErrorFill('#other_reason_not_first_aid', 'กรุณาระบุเหตุผลที่ไม่ได้ทำการปฐมพยาบาล')
      } else if (this.form.has_first_aid_id == 2 && this.form.type_first_aid_id.length == 0) {
        this.showErrorFill('#type_first_aid_id', 'กรุณาเลือกวิธีการปฐมพยาบาล')
      } else if (this.form.has_first_aid_id == 2 && this.form.type_first_aid_id.length != 0 && this.form.type_first_aid_id.includes('5') && !this.form.other_type_first_aid_id) {
        this.showErrorFill('#other_type_first_aid_id', 'กรุณาระบุวิธีการปฐมพยาบาลอื่นๆ')
      } else if (!this.form.has_type_deliver_id) {
        this.showErrorFill('#has_type_deliver_id', 'กรุณาเลือกการนำส่งสถานบริการสาธารณะสุข')
      } else if (this.form.has_type_deliver_id == 2 && this.form.type_deliver_id.length == 0) {
        this.showErrorFill('#type_deliver_id', 'กรุณาเลือกผู้ที่นำส่งสถานบริการสาธารณะสุข')
      } else if (this.form.has_type_deliver_id == 2 && this.form.type_deliver_id == 5 && this.form.other_deliver_type == '') {
        this.showErrorFill('#other_deliver_type', 'กรุณาระบุผู้ที่นำส่งสถานบริการสาธารณะสุข')
      } else {
        if (this.form.location_province) {

          this.form.location_province_id = this.form.location_province.id
        }
        if (this.form.location_district) {

          this.form.location_district_id = this.form.location_district.id
        }
        if (this.form.location_sub_district) {
          this.form.location_sub_district_id = this.form.location_sub_district.id
        }
        //change date format
        if (this.form.date_of_illness) {
          this.form.date_of_illness = moment(this.form.date_of_illness).format('YYYY-MM-DD')
        }
        if (this.form.date_of_treat) {
          this.form.date_of_treat = moment(this.form.date_of_treat).format('YYYY-MM-DD')
        }
        if (this.form.date_of_death) {
          this.form.date_of_death = moment(this.form.date_of_death).format('YYYY-MM-DD')
        }

        if (this.form.has_event_at_home_id) {
          this.form.distance_kilometre = 0
          this.form.distance_metre = 0
        }

        if (this.form.has_first_aid_id != 2) {
          this.form.type_people_first_aid_id = []
        }
        if (this.form.nationality_code) {

          this.form.nationality_code_id = this.form.nationality_code.id
        }

        let data = {
          id: this.form.id,
          event_id: this.event_form.id,
          order: this.form.order,
          unknown_person: this.form.unknown_person,
          alive: this.form.alive,
          title: this.form.title,
          other_title: this.form.other_title,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          id_number: this.form.id_number,
          nationality_code_id: this.form.nationality_code_id,
          address_no: this.form.address_no,
          village_no: this.form.village_no,
          location_province_id: this.form.location_province_id,
          location_district_id: this.form.location_district_id,
          location_sub_district_id: this.form.location_sub_district_id,
          school: this.form.school,
          gender_id: this.form.gender_id,
          age: this.form.age,
          age_month: this.form.age_month,
          patient_status_id: this.form.patient_status_id,
          injure_patient_status_id: this.form.injure_patient_status_id,
          other_injure_patient_status: this.form.other_injure_patient_status,
          date_of_illness: this.form.patient_status_id === 6 || this.form.patient_status_id === 1 ? '' : this.form.date_of_illness,
          date_of_treat: this.form.patient_status_id === 6 || this.form.patient_status_id === 1 ? '' : this.form.date_of_treat,
          date_of_death: parseInt(this.form.alive) !== 1 ? '' : this.form.date_of_death,
          swimming_id: this.form.swimming_id,
          swimming_ability_id: this.form.swimming_ability_id,
          people_with_patient_id: this.form.people_with_patient_id,
          activity_people_with_patient_id: this.form.activity_people_with_patient_id,
          other_activity_people_with_patient: this.form.other_activity_people_with_patient,
          activity_before_event_id: this.form.activity_before_event_id.toString(),
          other_activity_before_event: this.form.other_activity_before_event,
          caregiver_id: this.form.caregiver_id.toString(),
          other_caregiver: this.form.other_caregiver,
          distance_kilometre: this.form.distance_kilometre,
          distance_metre: this.form.distance_metre,
          has_event_at_home_id: this.form.has_event_at_home_id,
          has_floating_device_id: this.form.has_floating_device_id,
          floating_device_id: this.form.floating_device_id,
          other_floating_device: this.form.other_floating_device,
          has_life_jacket_id: this.form.has_life_jacket_id,
          risk_factors_id: this.form.risk_factors_id.toString(),
          other_risk_factors: this.form.other_risk_factors,
          rescuer_id: this.form.rescuer_id.toString(),
          type_help_id: this.form.type_help_id.toString(),
          throwing_tool: this.form.throwing_tool,
          hand_tool: this.form.hand_tool,
          other_type_help: this.form.other_type_help,
          drowning_time: this.form.drowning_time,
          drowning_time_hr: this.form.drowning_time_hr,
          has_first_aid_id: this.form.has_first_aid_id,
          reason_not_first_aid_id: this.form.reason_not_first_aid_id.toString(),
          other_reason_not_first_aid: this.form.other_reason_not_first_aid,
          type_people_first_aid_id: this.form.type_people_first_aid_id.toString(),
          other_type_people_first_aid: this.form.other_type_people_first_aid,
          type_first_aid_id: this.form.type_first_aid_id.toString(),
          other_type_first_aid_id: this.form.other_type_first_aid_id,
          has_type_deliver_id: this.form.has_type_deliver_id,
          type_deliver_id: this.form.type_deliver_id,
          other_deliver_type: this.form.other_deliver_type,
        }
        // console.log(data)
        this.$store.dispatch('Patient/savePatient', { id: this.form.id, data: data }).then(() => {
          // alert('บันทึกเรียบร้อย');
          this.showSavePatientFill()
          const order = this.form.order + 1

          if (order <= this.event_form.total_patient) {
            this.$store.dispatch('Patient/setOrder', order)
            this.$store.dispatch('Patient/showPatient', {
              event_id: this.form.event_id,
              order: order

            })
              .then(() => {
                console.log('then data', data)
                console.log('data.id 1', data.id)
                console.log('this.form.id 2', this.form.id)
                if (data.id) {
                  this.$router.push({
                    name: 'DrowningForm',
                    params: { order },
                  })
                  if (!this.form.id) {
                    this.$store.dispatch('Patient/clearFormData')
                    this.$store.dispatch('Patient/setOrder', order)
                  }
                } else {
                  this.$router.push({
                    name: 'DrowningForm',
                    params: { order }
                  })
                  this.$store.dispatch('Patient/clearFormData')
                  this.$store.dispatch('Patient/setOrder', order)
                }
              })
          }
        })
      }
    },
  }
}
</script>

<style scoped>
.text-head {
  color: #606060;
  font-weight: 700;
  text-align: center;
}

.form-div {
  background: #FCFCFC;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
}

.form-div label {
  font-size: 20px;
  color: #606060;
}

.form-control {
  font-size: 20px;
  font-weight: 700;
  color: #606060;
}

textarea {
  resize: none;
}

.custom-select option {
  font-weight: 700 !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #006738;
  background-color: #006738;
}

.custom-control-label::before {
  background-color: #FCFCFC;
  border: #006738 solid 2px;
}

.custom-control-label::before {
  background-color: #FCFCFC;
  border: #006738 solid 2px;
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-color: #FCFCFC;
  border: #006738 solid 2px;
  border-radius: 4px;
}

.btn-submit {
  font-size: 28px;
  font-weight: 700;
  background-color: #006738;
  padding: 4px 25px;
}

.btn-submit:active {
  background-color: white !important;
  color: #006738 !important;
}

.mx-datepicker {
  font-family: 'THSarabunNew', sans-serif !important;
  color: #495057 !important;
}
</style>
